import { CopyWellDetail } from 'business/models/CustomModels';
import { LayerDTO } from 'business/models/Models';
import { isNullOrUndefined, showSnackBar } from 'utils/Global';
let allWellsData: CopyWellDetail[];
let allLayersData: LayerDTO[];
let copyTypeData: any[];
let copyCrystalData: any;
const OBJECTSTORE = {
  name: 'WellStore',
  key: 'id',
};
const LAYERSTORE = {
  name: 'LAYERSTORE',
  key: 'id',
};
export const COPTYPESTORE = {
  name: 'CopyTypeStore',
  key: 'value',
};
const COPYCRYSTALINFOSTORE = {
  name: 'COPYCRYSTALINFOSTORE',
  key: 'value',
};
export const PROTEINSTORE = {
  name: 'PROTEINSTORE',
  key: 'id',
};
const OBJECTSTOREARRAY = [
  OBJECTSTORE,
  LAYERSTORE,
  COPTYPESTORE,
  COPYCRYSTALINFOSTORE,
  PROTEINSTORE,
];
const DB_NAME = 'CopyData';
const DB_VERSION = 5;

export enum CopyTypes {
  ProteinIngredients = 'ProteinIngredients',
  Layer = 'Layer',
  Well = 'Well',
}

export class IndexDBBuffer {
  public database: any;
  public db: any;

  constructor() {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = this.upgradeDbHandler;
  }

  upgradeDbHandler(this: IDBOpenDBRequest, ev: IDBVersionChangeEvent): any {
    const db = this.result;

    const objectStoreLength = db.objectStoreNames.length;
    const tempDB: any[] = [];
    for (let i = 0; i < objectStoreLength; i++) {
      tempDB.push(db.objectStoreNames[i]);
    }

    for (let i = 0; i < OBJECTSTOREARRAY.length; i++) {
      const result = tempDB.find((str) => str == OBJECTSTOREARRAY[i].name);
      if (isNullOrUndefined(result)) {
        db.createObjectStore(OBJECTSTOREARRAY[i].name, {
          keyPath: OBJECTSTOREARRAY[i].key,
        });
      }
    }
  }

  async ReadJSON(): Promise<CopyWellDetail[]> {
    try {
      await this.readIndexDb();
      return allWellsData;
    } catch (err) {
      console.error(err);
      showSnackBar('Cannot read from Clipboard');
    }
    return [];
  }

  async ReadJSONLayers(): Promise<LayerDTO[]> {
    try {
      await this.readLayersIndexDb();
      return allLayersData;
    } catch (err) {
      console.error(err);
      showSnackBar('Cannot read from Clipboard');
    }
    return [];
  }

  async ReadJSONCopyType(): Promise<any[]> {
    try {
      await this.readCopyTypeIndexDb();
      return copyTypeData;
    } catch (err) {
      console.error(err);
      showSnackBar('Cannot read from Clipboard');
    }
    return [];
  }

  async ReadJSONCopyCrystals(): Promise<any[]> {
    try {
      await this.readCopyCrystalIndexDb();
      return copyCrystalData;
    } catch (err) {
      console.error(err);
      showSnackBar('Cannot read from Clipboard');
    }
    return [];
  }

  async readFromIndexedDb<T>(storeName: string): Promise<T[]> {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = this.upgradeDbHandler;

      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction(storeName, 'readonly');
        const store = transaction.objectStore(storeName);
        const getAll = store.getAll();

        getAll.onsuccess = () => {
          resolve(getAll.result as T[]);
        };

        getAll.onerror = () => {
          reject(`Error reading from store: ${storeName}`);
        };
      };

      request.onerror = () => {
        reject(`Failed to open DB: ${DB_NAME}`);
      };
    });
  }

  async writeJson(
    data?: CopyWellDetail[],
    layerData?: LayerDTO[],
    copyType?: any,
    copyCrystal?: any,
    proteinIngredientsData?: any,
  ) {
    try {
      if (data !== null) {
        this.writeToIndexDb(data, OBJECTSTORE.name);
      } else if (layerData !== null) {
        this.writeToIndexDb(layerData, LAYERSTORE.name);
      }
      if (copyType !== null) {
        this.writeToIndexDb(copyType, COPTYPESTORE.name);
      }
      if (copyCrystal) {
        this.writeToIndexDb(copyCrystal, COPYCRYSTALINFOSTORE.name);
      }
      if (proteinIngredientsData) {
        this.writeToIndexDb(proteinIngredientsData, PROTEINSTORE.name);
      }
      return true;
    } catch (err) {
      console.error(err);
      showSnackBar('Could not copy to clipboard');
    }
    return false;
  }

  writeToIndexDb(data, storename?: string) {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;

    data.forEach((element) => {
      element.tabRect = undefined;
      element.tabNameRect = undefined;
    });
    request.onupgradeneeded = this.upgradeDbHandler;

    request.onsuccess = function (event) {
      db = request.result;
      const transaction = db.transaction(storename, 'readwrite');
      transaction.onsuccess = function (event) {
        showSnackBar('Copied to IndexedDb Successfully!');
      };

      const copyStore = transaction.objectStore(storename);

      copyStore.clear().onsuccess = function (evt) {
        data.forEach((element) => {
          const dbOpReq = copyStore.add(element);
          dbOpReq.onsuccess = function (event) {};
        });
      };
    };
  }

  async readIndexDb() {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;
    request.onupgradeneeded = this.upgradeDbHandler;

    await new Promise((res, rej) => {
      request.onsuccess = async function (event) {
        db = request.result;
        const transaction = db.transaction(OBJECTSTORE.name, 'readwrite');
        const copyStore = transaction.objectStore(OBJECTSTORE.name);

        const getAll = copyStore.getAll();

        await new Promise((resolve, reject) => {
          getAll.onsuccess = function (evt) {
            allWellsData = evt.target.result;
            resolve(true);
          };

          getAll.onerror = function (evt) {
            resolve(true);
          };
        });
        res(true);
      };

      request.onerror = function (event) {
        res(true);
      };
    });
  }

  async readLayersIndexDb() {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;
    request.onupgradeneeded = this.upgradeDbHandler;

    await new Promise((res, rej) => {
      request.onsuccess = async function (event) {
        db = request.result;
        const transaction = db.transaction(LAYERSTORE.name, 'readwrite');
        const copyStore = transaction.objectStore(LAYERSTORE.name);

        const getAll = copyStore.getAll();

        await new Promise((resolve, reject) => {
          getAll.onsuccess = function (evt) {
            allLayersData = evt.target.result;
            resolve(true);
          };

          getAll.onerror = function (evt) {
            resolve(true);
          };
        });
        res(true);
      };

      request.onerror = function (event) {
        res(true);
      };
    });
  }

  async readCopyTypeIndexDb() {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;

    request.onupgradeneeded = this.upgradeDbHandler;

    await new Promise((res, rej) => {
      request.onsuccess = async function (event) {
        db = request.result;
        const transaction = db.transaction(COPTYPESTORE.name, 'readwrite');
        const copyStore = transaction.objectStore(COPTYPESTORE.name);

        const getAll = copyStore.getAll();

        await new Promise((resolve, reject) => {
          getAll.onsuccess = function (evt) {
            copyTypeData = evt.target.result;
            resolve(true);
          };

          getAll.onerror = function (evt) {
            resolve(true);
          };
        });
        res(true);
      };

      request.onerror = function (event) {
        res(true);
      };
    });
  }

  async readCopyCrystalIndexDb() {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;

    request.onupgradeneeded = this.upgradeDbHandler;

    await new Promise((res, rej) => {
      request.onsuccess = async function (event) {
        db = request.result;
        const transaction = db.transaction(COPYCRYSTALINFOSTORE.name, 'readwrite');
        const copyStore = transaction.objectStore(COPYCRYSTALINFOSTORE.name);

        const getAll = copyStore.getAll();

        await new Promise((resolve, reject) => {
          getAll.onsuccess = function (evt) {
            copyCrystalData = evt.target.result;
            resolve(true);
          };

          getAll.onerror = function (evt) {
            resolve(true);
          };
        });
        res(true);
      };

      request.onerror = function (event) {
        res(true);
      };
    });
  }

  async getCount(): Promise<number> {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;
    let count = 0;

    request.onupgradeneeded = this.upgradeDbHandler;

    await new Promise((res, rej) => {
      request.onsuccess = async function (event) {
        db = request.result;
        const transaction = db.transaction(OBJECTSTORE.name, 'readwrite');
        const copyStore = transaction.objectStore(OBJECTSTORE.name);

        const countRequest = copyStore.count();

        await new Promise((resolve, reject) => {
          countRequest.onsuccess = function (evt) {
            count = evt.target.result;
            resolve(true);
          };

          countRequest.onerror = function (evt) {
            count = 0;
            resolve(true);
          };
        });
        res(true);
      };

      request.onerror = function (event) {
        res(true);
      };
    });
    return count;
  }

  async getLayerStoreCount(): Promise<number> {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    let db;
    let count = 0;

    request.onupgradeneeded = this.upgradeDbHandler;

    await new Promise((res, rej) => {
      request.onsuccess = async function (event) {
        db = request.result;
        const transaction = db.transaction(LAYERSTORE.name, 'readwrite');
        const copyStore = transaction.objectStore(LAYERSTORE.name);

        const countRequest = copyStore.count();

        await new Promise((resolve, reject) => {
          countRequest.onsuccess = function (evt) {
            count = evt.target.result;
            resolve(true);
          };

          countRequest.onerror = function (evt) {
            count = 0;
            resolve(true);
          };
        });
        res(true);
      };

      request.onerror = function (event) {
        res(true);
      };
    });
    return count;
  }
}
